package com.ijoin.ui.components

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.ijoin.ui.design.EventCardAccentDark
import com.ijoin.ui.design.EventCardCorner
import com.ijoin.ui.design.EventCardOutline
import com.ijoin.ui.design.EventCardSurface
import io.nayuki.qrcodegen.QrCode
import kotlin.math.min

@Composable
fun TicketQrCode(
    data: String?,
    modifier: Modifier = Modifier
) {
    val qrCode = remember(data) {
        runCatching {
            data?.takeIf { it.isNotBlank() }?.let {
                QrCode.encodeText(it, QrCode.Ecc.MEDIUM)
            }
        }
    }

    val surfaceColor = EventCardSurface
    val moduleColor = EventCardAccentDark
    val placeholderColor = MaterialTheme.colorScheme.onSurfaceVariant

    Surface(
        modifier = modifier,
        shape = RoundedCornerShape(EventCardCorner),
        tonalElevation = 1.dp,
        color = surfaceColor,
        border = BorderStroke(1.dp, EventCardOutline)
    ) {
        val result = qrCode?.getOrNull()
        if (result != null) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(24.dp),
                contentAlignment = Alignment.Center
            ) {
                Canvas(modifier = Modifier.fillMaxSize()) {
                    val moduleCount = result.size
                    val squareSize = min(size.width, size.height)
                    val cellSize = squareSize / moduleCount
                    val offsetX = (size.width - moduleCount * cellSize) / 2f
                    val offsetY = (size.height - moduleCount * cellSize) / 2f
                    for (y in 0 until moduleCount) {
                        for (x in 0 until moduleCount) {
                            if (result.getModule(x, y)) {
                                val left = offsetX + x * cellSize
                                val top = offsetY + y * cellSize
                                drawRect(
                                    color = moduleColor,
                                    topLeft = Offset(left, top),
                                    size = Size(cellSize, cellSize)
                                )
                            }
                        }
                    }
                }
            }
        } else {
            val placeholder = data ?: "QR"
            Box(
                modifier = Modifier.fillMaxSize(),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    text = placeholder,
                    textAlign = TextAlign.Center,
                    style = MaterialTheme.typography.titleMedium,
                    color = placeholderColor
                )
            }
        }
    }
}
